import request from "@/utils/request";

// 列表(主数据列表)
export function loadAppConsumerStoreScanWinRecordListDataApi(data) {
  return request({
    url: "web/appConsumerStoreScanWinRecord/listData",
    method: "post",
    data
  });
}
// 导出
export function loadAppConsumerStoreScanWinRecordExportDataApi(data) {
  return request({
    url: "web/appConsumerStoreScanWinRecord/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateAppConsumerStoreScanWinRecordApi(data) {
  return request({
    url: "web/appConsumerStoreScanWinRecord/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initAppConsumerStoreScanWinRecordApi(data) {
  return request({
    url: "web/appConsumerStoreScanWinRecord/init",
    method: "post",
    data
  });
}

// 根据条件查询
export function findAppConsumerStoreScanWinRecordByConditionApi(data) {
  return request({
    url: "web/appConsumerStoreScanWinRecord/findListByCondition",
    method: "post",
    data
  });
}
